import { useEffect, useState } from "react";
import Bar from "./Bar";
import { getTime } from "./utils";

import "./styles.css";

const texts = [
  "Hey there 🙋‍♂️ I'm James",
  "I'm a full stack software engineer",
  "You can contact me at:",
  <div className="links">
    <a
      href="https://www.linkedin.com/in/james-dowell/"
      target="_blank"
      rel="noreferrer"
    >
      linkedin.com/in/james-dowell/
    </a>
    <a href="https://github.com/j-dowell" target="_blank" rel="noreferrer">
      github.com/j-dowell/
    </a>
  </div>,
  <div>
    <div>Or visit the rest of my site: </div>
    <a href="https://jamesdowell.dev" target="_blank" rel="noreferrer">
      jamesdowell.dev
    </a>
  </div>,
  `Have a good ${getTime()}! 👋`,
];

export default function App() {
  const [max, setMax] = useState(0);

  const handleNext = (index) => setMax(index + 1);

  return (
    <div className="App">
      <div className="text-container">
        {texts.map(
          (text, index) =>
            index <= max && (
              <Bar
                key={index}
                text={text}
                index={index}
                onFinish={() => handleNext(index)}
              />
            )
        )}
      </div>
    </div>
  );
}
